const { navigate } = require('gatsby');

const isBrowser = typeof window !== 'undefined';

const getBaseUrl = () => {
  if (!isBrowser) return null;

  const { protocol, host } = window.location;
  return `${protocol}//${host}`;
};

const getPortugalSitBaseUrl = () => {
  return process.env.OPCO_NAME === 'portugal sit' ? 'https://www.vodafone.pt:449' : null;
};

const addParamsToUrl = (url, params = {}) => {
  if (!url) return url;

  try {
    const urlObj = new URL(url);
    Object.entries(params).forEach(([key, value]) => {
      urlObj.searchParams.append(key, value);
    });
    return urlObj.toString();
  } catch (error) {
    console.error('Invalid URL:', url);
    return url;
  }
};

const transformPathForPT = path => {
  if (!path || typeof path !== 'string') return path;

  let transformedPath = path.replace('product-list/', '').replace('/nce-', '/').replace('/basket', '/carrinho');

  if (transformedPath.includes('marketplace/') && !transformedPath.includes('business/marketplace')) {
    transformedPath = transformedPath.replace('marketplace/', 'business/marketplace/');
  }

  return transformedPath;
};

const ensureAbsoluteUrl = path => {
  if (!path) return path;

  const isRelativeUrl = !path.startsWith('http') && !path.startsWith('//');
  if (!isRelativeUrl) return path;

  const baseURL = getBaseUrl() || getPortugalSitBaseUrl();
  if (!baseURL) return path;

  try {
    return new URL(path, baseURL).toString();
  } catch (error) {
    console.error('Failed to create absolute URL:', error);
    return path;
  }
};

const usingOpcoUrl = (path, shouldNavigate = false, navigateParams = {}) => {
  if (!path) return null;

  let processedPath = path;
  const isPT = process.env.GATSBY_OPCO === 'PT';

  if (isPT) {
    processedPath = transformPathForPT(processedPath);
    processedPath = ensureAbsoluteUrl(processedPath);
  }

  if (!shouldNavigate) {
    return processedPath;
  }

  if (isPT) {
    const finalUrl = addParamsToUrl(processedPath, navigateParams);
    if (isBrowser) {
      window.location.href = finalUrl;
    }
  } else if (isBrowser) {
    navigate(processedPath, navigateParams);
  }

  return null;
};

const getOpcoUrl = path => {
  if (!path) return path;
  return process.env.GATSBY_OPCO === 'PT' ? transformPathForPT(path) : path;
};

module.exports = usingOpcoUrl;
module.exports.getOpcoUrl = getOpcoUrl; // Named export
